import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import 'leaflet/dist/leaflet.css';
import { HelmetProvider } from "react-helmet-async";

// ⬇️ Insert here, before render()
// --- DEV ONLY: silence Chrome's ResizeObserver overlay noise ---
if (process.env.NODE_ENV === "development") {
  const isResizeObserverNoise = (msg) =>
    typeof msg === "string" &&
    (msg.includes("ResizeObserver loop completed with undelivered notifications") ||
     msg.includes("ResizeObserver loop limit exceeded"));

  // Block the overlay in the capture phase
  const stopRoOverlay = (e) => {
    const m = (e?.message || e?.reason?.message || "").toString();
    if (isResizeObserverNoise(m)) {
      e.stopImmediatePropagation?.();
      e.preventDefault?.();
    }
  };
  window.addEventListener("error", stopRoOverlay, true);
  window.addEventListener("unhandledrejection", stopRoOverlay, true);

  // Filter console.error spam for the same messages
  const origError = console.error;
  console.error = (...args) => {
    if (args?.length && typeof args[0] === "string" && isResizeObserverNoise(args[0])) {
      return;
    }
    origError(...args);
  };
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
